import { IFetchSpecialtyAsyncAction, SpecialtyActionTypes } from "./specialtyTypes"

export const fetchSpecialtiesAsync = (): IFetchSpecialtyAsyncAction => {
  return {
    type: SpecialtyActionTypes.FETCH_SPECIALTIES_ASYNC_PENDING
  }
}
